import React, {useState} from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useAlert } from "../../hooks/AlertHook";
import { API_ENDPOINTS } from "../../config/api";

const LoginForm = (props) => {
  const [errorMsg, setErrorMsg] = useState(null);
  const navigate = useNavigate()
  const { register, handleSubmit} = useForm();
  const alerta = useAlert();

  const onSubmit = data => {
    setErrorMsg(null);

    axios.post(
      API_ENDPOINTS.SIGNIN,
      data,
    ).then((respuesta) => {
      // if (respuesta.data.isError) {
      //   setErrorMsg(respuesta.data.message)
      // } else {
        localStorage.setItem('BACK_API', JSON.stringify(respuesta.data));
        alerta.setHomeLink('/dash/devices');
        navigate('/dash/devices')
      // }
    }).catch((error) => {
      console.log('error:', error)
      setErrorMsg(error)
    });
  };

  return (
    <div>
      <div className="flex bg-vide-gray-soft flex-col justify-center items-center h-navbar">
        <div className="min-w-[400px]">
          <div>
            <h1 className="mb-5 text-4xl font-bold text-vide-purple">
              Welcome
              <br />{" "}
              <div className="text-vide-black-text">to the command center</div>
            </h1>
            <p className="mb-10 text-vide-black-text">
              Please, login to gain access to the cloud
            </p>
          </div>
          <div>
            <div className="mt-6">
              <form action="#" method="POST" className="space-y-6" onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Email Address
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    className="form-input"
                    {...register("email")}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="password" className="form-label">
                    Password
                  </label>
                  <div className="mt-1">
                    <input
                      id="password"
                      name="password"
                      type="password"
                      autoComplete="current-password"
                      required
                      className="form-input"
                      {...register("password")}
                    />
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <input
                      id="remember-me"
                      name="remember-me"
                      type="checkbox"
                      className="h-4 w-4 text-vide-purple focus:ring-vide-purple border-gray-300 rounded"
                    />
                    <label
                      htmlFor="remember-me"
                      className="ml-2 block text-sm text-gray-900"
                    >
                      Remember me
                    </label>
                  </div>
                  <br />
                  <div className="text-sm">
                    <Link to="/auth/recovery" className="font-medium text-vide-purple hover:text-vide-purple">
                      Forgot your password?
                    </Link>
                  </div>
                </div>

                <div>
                  <p className={`mb-4 text-xs text-center text-red-500 ${!errorMsg ? 'hidden' : ""}`}>
                    Incorrect credentials, verify them and try again.
                  </p>
                  
                  <button type="submit" className="btn-primary">Access Cloud</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
